import { Form, message } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import VoucherForm from "../../../component/voucherForm";
import { useCookies } from "react-cookie";
import axiosInstance from "../../../utils/axios";

export default function VoucherManageDetail() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [initialValues, setInitialValues] = useState({});
  const params = useParams();
  const id = params?.id;
  const [cookies, setCookie, removeCookie] = useCookies(['admin']);

  const fetchVoucher = async () => {
    await axiosInstance.get(`/voucher/getById/${params?.id}`)
      .then((res) => {
        const data = res?.data?.data;
        const values = {
          ...data,
        };
        setInitialValues(values);
      });
  };

  const onSubmit = async (values) => {
    try {
      if (id && id !== "tao-moi") {
        await axiosInstance.post(`/voucher/update/${id}`, values)
          .then((res) => {
            message.success(String(res?.data?.message));
          });
      } else {
        await axiosInstance.post(`/voucher/create`, values)
          .then((res) => {
            message.success(String(res?.data?.message));
          });
      }
      navigate("/admin/quan-ly-ma-giam-gia");
    } catch (error) {
      message.error(error);
    }
  };

  useEffect(() => {
    if (id && id !== "tao-moi") fetchVoucher();
    form.resetFields();
  }, [form, id]);

  return (
    <VoucherForm
      id={id !== "create" ? id : undefined}
      initialValues={initialValues}
      onSubmit={onSubmit}
    />
  );
}
